var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteminting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.533,
    height: 25.533,
    viewBox: "0 0 25.533 25.533",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "minting",
    d: "M1,25l9.366-9.366m0,0L5.29,10.558a2,2,0,0,1-.051-2.775l4.886-5.262A2,2,0,0,1,13,2.468L23.532,13a2,2,0,0,1-.053,2.88l-5.262,4.886a2,2,0,0,1-2.775-.051Z",
    transform: "translate(0.414 -0.882)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteminting);
export default __webpack_public_path__ + "static/media/whiteminting.0208a9cc4803317d68d56fd6910ad173.svg";
export { ForwardRef as ReactComponent };